import { render, staticRenderFns } from "./ProtocolTypeSetting.vue?vue&type=template&id=1c4c9970"
import script from "./ProtocolTypeSetting.vue?vue&type=script&lang=js"
export * from "./ProtocolTypeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports